// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"314":"orderdetail","377":"purchases","594":"about"}[chunkId] || chunkId) + "." + {"314":"ed87438e","377":"d1ec70bf","594":"3d56f43e","998":"be6aa167"}[chunkId] + ".css";
};